import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, getCurrentInstance } from 'vue'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'QixinOrder',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const filterData = reactive({
    from: '',
    to: '',
});

const onExport = () => {
    if(!filterData.from || !filterData.to){
        return proxy.$message({ type: 'error', message: '请选择下单时间范围' })
    }
    
    const params = {
        ...filterData,
        user_id: store.state.user.userInfo.id
    }
    
    window.open(`${Keys.baseUrl}/sys/admin/qixinProducts?${joinParams(params)}&is_export=1`)
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    class: "mb15",
    shadow: "hover"
  }, {
    header: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("div", {
        class: "card-header",
        style: {"font-size":"14px","font-weight":"bold"}
      }, [
        _createElementVNode("span", null, "齐心上下架数据")
      ], -1)
    ])),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: true,
        class: "filter-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "开始日期：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: filterData.from,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterData.from) = $event)),
                type: "date",
                placeholder: "选择开始日期",
                class: "filter-item date-input",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"]),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "filter-divider" }, " -- ", -1)),
              _createVNode(_component_el_date_picker, {
                modelValue: filterData.to,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterData.to) = $event)),
                type: "date",
                placeholder: "选择结束日期",
                class: "filter-item date-input",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: onExport,
                class: "export-btn"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("导出")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})